import { Component, OnInit} from '@angular/core';
import { ActivatedRoute,  Router } from '@angular/router';
import { Message } from 'primeng/components/common/message';
import { SelectItem } from 'primeng/components/common/selectitem';
import { BusinessCategory, EditBusinessCategory } from '../../../../models/inModels/business-category';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { BusinessService as BusinessCategoryService } from '../../../../services/business/business-category.service';


@Component({
  selector: 'app-business-category-edit',
  templateUrl: './business-category-edit.component.html',
  styleUrls: ['./business-category-edit.component.css']
})
export class BusinessCategoryEditComponent implements OnInit {
  id;
  model: EditBusinessCategory;
  loading = false;
  messages: Message[];
  error: Message[];
  categories: SelectItem[];
  selectedCategory;
  groups: string[];
  selectedGroup;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private businessService: BusinessCategoryService,
    private auth: AuthenticationService) {
    console.log(this.route.snapshot.paramMap.get('Id'))
    this.id =this.route.snapshot.paramMap.get('Id');
   }
  ngOnInit(): void {
    this.getCategory();
  }

  getCategory(){
    this.loading = true;
    this.businessService.get(this.id).then(
      res => {
        this.model = new EditBusinessCategory(res);
        this.selectedCategory = {};
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.error=[];
        this.error.push({severity: 'error', summary: 'Error', detail: error });
      });
  }
  initCategoryDropDown(event){
    this.businessService.getDropdown(event).then(
      x=>{
        this.categories = x;
      },
      error => {
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }
  initGroupDropdown(event): void {
		this.businessService.getGroupsList(event).then(
			result => {
        
        this.groups = result;

			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

  setGroup(): void {
    this.model.GroupId = this.selectedGroup.value;
	}

  setCategory(): void {
    this.model.Id = this.selectedCategory.value;
  }
  goBack(): void {
    this.router.navigate(['/business-category']);
}

save(){
  this.loading = true;
  this.businessService.update(this.model).then(
    res => {
      this.loading = false;
      this.model = new EditBusinessCategory(res);
      this.messages = [];
      this.messages.push({ severity: 'success', summary: 'Success', detail: 'Category Updated'});
    },
    error => {
      this.loading = false;
      this.messages =[];
      this.messages.push({ severity: 'error', summary: 'Error', detail: error });;
    });
 }
}



// WEBPACK FOOTER //
// ./src/app/components/business/business-category/business-category-edit/business-category-edit.component.ts